import { styled, TableCell } from '@mui/material';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const StyledTableHeaderCell = styled(TableCell)<{
  enabledarktheme: boolean;
}>(({ enabledarktheme }) => {
  const palette = enabledarktheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return {
    color: palette.white,
    backgroundColor: palette.tableHeader,
    border: 'none',
    fontSize: '12px',
    pl: 3,
    transition: 'all 0.3s ease-in-out',
  };
});
